import * as React from 'react';
import AddKeyButton from './AddKeyButton';
import CreateKeyValueRegexButton from './CreateKeyValueRegexButton';
const KeyValueRegexButtons = ({ callbackAdd, callbackCreate, keyValueRegexId, name, }) => (React.createElement("div", { style: { minWidth: 'fit-content' } },
    React.createElement(CreateKeyValueRegexButton, { callback: callbackCreate, name: name }),
    keyValueRegexId !== undefined && name !== undefined ? (React.createElement(AddKeyButton, { callback: callbackAdd, keyValueRegexId: keyValueRegexId, name: name })) : undefined));
export default KeyValueRegexButtons;
